import axios from "axios";
import { getToken } from "../../auth/authService";

const BASE = process.env.REACT_APP_BASE_URL;
const auth = () => ({ Authorization: `Bearer ${getToken()}` });

export const fetchMediaVideos = async ({ page = 0, size = 20, visibility = "", videoUse = "", showDeleted = false } = {}) => {
  try {
    const params = { page, size };
    if (visibility) params.visibility = visibility;
    if (videoUse) params.videoUse = videoUse;
    if (showDeleted) params.showDeleted = true;
    const res = await axios.get(`${BASE}/admin/media-videos`, { headers: auth(), params });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: [], message: err.response?.data?.message || "Failed to fetch videos" };
  }
};

export const uploadMediaVideo = async ({ file, name, visibility, videoUse, description, courseId }, onUploadProgress) => {
  try {
    console.log("[VideoService] uploadMediaVideo called", { name, visibility, videoUse, description, courseId, file: file?.name, size: file?.size });
    const form = new FormData();
    form.append("file", file);
    form.append("name", name);
    form.append("visibility", visibility);
    form.append("videoUse", videoUse);
    if (description) form.append("description", description);
    if (courseId) form.append("courseId", courseId);
    console.log("[VideoService] FormData keys:", [...form.keys()]);
    const res = await axios.post(`${BASE}/admin/media-videos/upload`, form, {
      headers: { ...auth(), "Content-Type": "multipart/form-data" },
      onUploadProgress,
    });
    console.log("[VideoService] upload response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[VideoService] upload error:", err.response?.status, err.response?.data, err.message);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Upload failed" };
  }
};

export const replaceMediaVideo = async (id, file) => {
  try {
    const form = new FormData();
    form.append("file", file);
    const res = await axios.put(`${BASE}/admin/media-videos/${id}/replace`, form, {
      headers: { ...auth(), "Content-Type": "multipart/form-data" },
    });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Replace failed" };
  }
};

export const updateMediaVideoMeta = async (id, { name, videoUse, description, courseId }) => {
  try {
    const res = await axios.patch(
      `${BASE}/admin/media-videos/${id}/meta`,
      { name, videoUse, description, courseId: courseId || null },
      { headers: auth() }
    );
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed" };
  }
};

export const restoreMediaVideo = async (id) => {
  try {
    const res = await axios.patch(`${BASE}/admin/media-videos/${id}/restore`, {}, { headers: auth() });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Restore failed" };
  }
};

export const softDeleteMediaVideo = async (id) => {
  try {
    const res = await axios.delete(`${BASE}/admin/media-videos/${id}`, { headers: auth() });
    return { status: res.status };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Delete failed" };
  }
};

export const hardDeleteMediaVideo = async (id) => {
  try {
    const res = await axios.delete(`${BASE}/admin/media-videos/${id}/hard`, { headers: auth() });
    return { status: res.status };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Hard delete failed" };
  }
};

export const streamMediaVideo = async (id) => {
  return fetch(`${BASE}/admin/media-videos/${id}/stream`, { headers: auth() });
};

// ── Media Video Uses ──────────────────────────────────────
export const fetchMediaVideoUses = async () => {
  try {
    const res = await axios.get(`${BASE}/admin/media-video-uses`, { headers: auth() });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: [], message: err.response?.data?.message || "Failed to fetch video uses" };
  }
};

export const createMediaVideoUse = async (name) => {
  try {
    const res = await axios.post(`${BASE}/admin/media-video-uses`, { name }, { headers: auth() });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed" };
  }
};

export const deleteMediaVideoUse = async (id) => {
  try {
    const res = await axios.delete(`${BASE}/admin/media-video-uses/${id}`, { headers: auth() });
    return { status: res.status };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Delete failed" };
  }
};
